import { Field, reduxForm } from 'redux-form';
import { LoginButton, LoginButtonDisabled } from '../../../components/buttons';
import { logoutAction, superAdminLoginAction } from './actions/LoginActions';
import {isValidName,  renderTextField, renderPasswordField} from '../../../components/reduxFields';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import validate from './validate';
// var macaddress = require('macaddress');

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  onSubmit(authData) {
    this.props.superAdminLoginAction(authData);
  }
  renderLoginForm() {
    const { handleSubmit, errorMessage, successMessage, loginHeaderComponent } = this.props;
   
      return (
        <div className="login-fields">
          {loginHeaderComponent}
          <form autocomplete="off" className="readmin-form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>

            {(errorMessage && <div className="alert-danger">{errorMessage}</div>)
              ||
            (successMessage && <div className="alert-success">{successMessage}</div>)}
            <Field
              name="userName"
              type="text"
              maxLength="60"
              normalize={isValidName}
              label="User Name"
              autoFocus={true}
              component={renderTextField}
            />
            <Field             
              name="password"
              maxLength="30"
              label="Password"
              type="password"
              component={renderPasswordField}
            />
            <div className="mt-15">
              {/* <Field
                name="rememberme"
                label="Remember Me"
                className="rem custm_check"
                component={renderCheckBox} /> */}
              <div className="frgtpwd">
                <NavLink exact to="/webadmin/forgot-password">Forgot Password?</NavLink>
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="mt-30">
              {this.props.authenticating ? <LoginButtonDisabled label="Logging In..." /> : <LoginButton label="Log In" />}
            </div>
          </form>
        </div>
      );
   
  }

  render() {
    return (
      <div>
        {this.renderLoginForm()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticating: state.login.authenticating,
    // authenticatingToken: state.login.authenticatingToken,
    // errorMessage: state.login.errorMessage,
  };
}

Login = reduxForm({
  form: 'loginForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(Login);

export default connect(mapStateToProps, { superAdminLoginAction, logoutAction })(Login);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/logins/login.js